<template lang="pug">
  .base_img_root(
    :style="{ 'height': `${imgSize || imgHeight}px`, 'width': `${imgSize || imgWidth}px`, 'filter': `opacity(${opacity})` }"
  )
    img.img-wrap(
      v-if="imgSrc"
      :src="imgSrc"
    )
</template>

<script>
export default {
  name: 'BaseImg',

  props: {
    // icons || images
    imgType: {
      type: String,
      required: true
    },
    // file name
    imgName: {
      type: String,
      required: true
    },
    // require: imgSize || (imgWidth && imgHeight)
    imgSize: {
      type: Number,
      default: 0
    },
    imgWidth: {
      type: Number,
      default: 25
    },
    imgHeight: {
      type: Number,
      default: 25
    },
    // if file extension isn't `svg`, props cur extension
    fileExtension: {
      type: String,
      default: 'svg'
    },
    opacity: {
      type: Number,
      default: 1
    }
  },

  computed: {
    // 有抓不到圖檔的可能
    imgSrc () {
      const { imgType, imgName, fileExtension } = this
      let file = null

      try {
        file = require(`@/assets/${imgType}/${imgName}.${fileExtension}`)
      } catch {
        file = null
      }

      return file
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import 'BaseImg.styl'
</style>
